import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../core';

import { TipoArquivoFilter } from '../../filter';
import { TipoArquivoSearchHttpService } from '../../services';
import { TipoArquivoSearch } from '../../tipo-arquivo-search';
import { TipoArquivoSearchOrderBy } from '../../tipo-arquivo-search-orderby';
import { TipoArquivoRef } from '../../ref';
import { TipoArquivoSituacao } from '../../situacao';

@Component({
    selector: 'sgt-tipo-arquivo-form-select',
    templateUrl: './tipo-arquivo-form-select.component.html',
    styleUrls: ['./tipo-arquivo-form-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TipoArquivoFormSelectComponent), multi: true },
    ]
})
export class TipoArquivoFormSelectComponent implements OnInit {
    /** ID do tipo de arquivo */
    @Input() ngModel: number;
    /** Ao alterar o tipo de arquivo */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo de arquivo */
    @Input() tipoArquivo: TipoArquivoRef;
    @Output() tipoArquivoChange = new EventEmitter<TipoArquivoRef>();

    /** Tipos de arquivos */
    tiposArquivos: TipoArquivoSearch[];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUM TIPO'
    /** Se deve filtrar somente os tipos de arquivos ativos */
    @Input() somenteAtivos = false;
    /** Filtro das referências que deve ser considerado para exibir os tipos de arquivos disponíveis */
    @Input() referenciasFilter: number[];

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private tipoArquivoSearchHttpService: TipoArquivoSearchHttpService) { }

    ngOnInit() {
        this.search();
    }


    /** Pesquisa os tipos de arquivos */
    private search() {
        this.tiposArquivos = [];


        const filter = new TipoArquivoFilter();
        // Somente ativos
        filter.situacoes = this.somenteAtivos ? [TipoArquivoSituacao.ATIVO] : null;
        // Referências
        filter.referencias = this.referenciasFilter;

        this.tipoArquivoSearchHttpService.search(filter, TipoArquivoSearchOrderBy.Nome, 'asc', null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                tiposArquivos => {
                    this.tiposArquivos = tiposArquivos;

                    if (this.tipoArquivo) {
                        const indexTipoArquivo = this.tiposArquivos?.findIndex(tipoArquivoFilter => tipoArquivoFilter.id === this.tipoArquivo.id);
                        if (indexTipoArquivo < 0) {
                            this.tiposArquivos.unshift(this.tipoArquivo);
                        }

                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os tipos de arquivos', error)
            );
    }

    /** Ao alterar o tipo de arquivo */
    onChange(idTipoArquivo: number) {
        this.ngModel = idTipoArquivo;
        this.propagateChange(this.ngModel);

        this.tipoArquivo = this.tiposArquivos?.find(tipoArquivoFilter => tipoArquivoFilter.id === idTipoArquivo);
        this.tipoArquivoChange.emit(this.tipoArquivo);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
